console.log('custom.js is loaded');

(function($) {
  $(document).ready(function() {
    $('.slick-slideshow').on('init reInit afterChange', function (event, slick, currentSlide) {
      const current = currentSlide ?? 0;
  
      $('.slick-slide').each(function () {
        const $slide = $(this);
        const slideIndex = parseInt($slide.attr('data-slick-index'), 10);
  
        if (slideIndex === current) {
          $slide.removeClass('dimmed');
        } else {
          $slide.addClass('dimmed');
        }
      });
    });
    
    $('.slick-slideshow').slick({
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      fade: false, // fadeをoffにしないとcenterModeが効きません
      speed: 800,
      centerMode: false, // デフォルトはfalseにしておく
      centerPadding: '100px',
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            centerMode: false
          }
        },
        {
          breakpoint: 100000, // 1200px以上
          settings: {
            centerMode: true,
            centerPadding: '10%' // 必要に応じて調整
          }
        }
      ]
    });
  });

  $('.topics_slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        centerPadding: '100px',
        centerMode: true,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>',
        adaptiveHeight: false,
        responsive: [
            {
            breakpoint: 1190,
            settings: {
                centerPadding: '100px',
                slidesToShow: 2
            }
            },
            {
            breakpoint: 992,
            settings: {
                centerPadding: '50px',
                slidesToShow: 2
            }
            },
            {
            breakpoint: 576,
            settings: {
                centerPadding: '20px',
                slidesToShow: 1
            }
            }
        ]
    });

})(jQuery);




